import { takeEvery, all, put, select } from 'redux-saga/effects'
import { startSubmit, stopSubmit } from 'redux-form/immutable'
import i18next from 'i18next'

import { createLevel } from '../actions'
import { push } from 'connected-react-router'
import { CREATE_LEVEL_FORM_NAME as FORM_NAME } from 'app/constants/levels'
import { showSuccess } from 'store/entities/toastr/utils'
import { getViewProtrackId } from 'store/entities/protracks/selectors'
import { MICROACTIONS_PATH } from 'app/constants/navLinks'

export function* handlePostRequest({ payload }) {
  yield put(startSubmit(FORM_NAME))
}

export function* handlePostSuccess({ payload: { data } }) {
  const protrackId = yield select(getViewProtrackId)
  yield put(push(`${MICROACTIONS_PATH}/protracks/${protrackId}`, { forceLeave: true }))
  showSuccess({ content: i18next.t('You successfully created Level', { data: data.order }) })
}

export function* handlePostFail(error) {
  console.error('error', error)
  yield put(stopSubmit(FORM_NAME))
}

export default function* createLevelSaga() {
  yield all([
    takeEvery(createLevel.toString(), handlePostRequest),
    takeEvery(createLevel.success.toString(), handlePostSuccess),
    takeEvery(createLevel.fail.toString(), handlePostFail),
  ])
}
